import { PartData } from './part.type';
import { PartTypeActionLiveSearchItem } from './partType.type';
import { ImagePopupSlide } from '../components/atoms/ImagePopup';

export enum PartActionType {
  INSTALL = 'install',
  REPLACE = 'replace',
  REMOVE = 'remove',
  DOA = 'doa',
  CLEAN = 'clean',
  TEST = 'test',
  REPAIR = 'repair',
  ADJUST = 'adjust'
}

export enum PartActionValidateType {
  INSTALL = 'install',
  REPLACE = 'replace',
  REMOVE = 'remove',
  DOA = 'doa',
  CLEAN = 'clean',
  TEST = 'test',
  REPLACEIN = 'replace-in',
  REPLACEOUT = 'replace-out',
  DOAIN = 'doa-in',
  DOAOUT = 'doa-out',
}

export enum Action {
  IN = 'in',
  OUT = 'out'
}


export interface PartActionCard {
  id: number;
  actionId?: number;
  partTypeId?: number;
  partId?: number;
  ns_partId?: number;
  name?: string;
  category?: string;
  sw?: string;
  hw?: string;
  fw?: string;
  ft?: string;
  serial?: string;
  qty?: number;
  condition?: string;
  conditionName?: string;
  location?: string;
  locationId?: number;
  notes?: string;
  type?: string;
  images?: Array<ImagePopupSlide>;
  serviceId?: number;
  isInSiblingHierarchy?: boolean;
  isInSiteHierarchy?: boolean;
  isUnderClientStructure?: boolean;
  isAccepted?: boolean;
  desiredParentId?: number;
  desiredParentSerial?: string;
  desiredParentLocationId?: number;
  locationTypeCode?: string;
  repairActions?: string[];
  labourTime?: string;
  testOutcome?: string;
  observedFaultId?: number;
  observedFaultName?: string;
  isExceptionalCreation?: boolean;
  deviceImageS3Key?: string;
  deviceImageFileName?: string;
  serialImageS3Key?: string;
  serialImageFileName?: string;
}

export interface CustomisePartActionCard { 
  value: PartActionCard;
  outValue?: PartActionCard; 
  inValue?: PartActionCard;
  warning?: string;
  execute?: boolean;
  executionCompleted?: boolean;
}

export interface CreatePartActionResponse { 
  actionTypeCode: string;
  serviceId: number;
  installedOrMaintainedPartData: JSON;
  removedPartData: JSON;
  notes: string;
  execute: boolean;
}

export interface PartActionResponse { 
  id: number;
  actionTypeCode: string;
  serviceId: number;
  installedOrMaintainedPartData: PartData;
  removedPartData: PartData;
  notes: string;
}

export interface AddPartActionResponse { 
  id: number;
  actionTypeCode: string;
  serviceId: number;
  installedOrMaintainedPartData: PartData;
  removedPartData: PartData;
  notes: string;
  createdAt: string;
  createdBy: number;
  updatedAt: string;
  updatedby: number;
}

export interface PartActionWarningInOutDependancies { 
  serial1?: string;
  partTypeName?: string;
}

export interface PartActionWarningDependancies { 
  in: PartActionWarningInOutDependancies;
  out: PartActionWarningInOutDependancies;
}

export interface PartActionInOutHelperText {
  partTypeHelperText: string;
  partSerialHelperText: string;
  locationHelperText: string;
  noteHelperText: string;
  qtyHelperText?: string;
}

export interface PartActionCardHelperText {
  in: PartActionInOutHelperText;
  out: PartActionInOutHelperText;
  id?: number;
  partActionType?: string;
}

export interface PartCreationOptionData { 
  newPartSerial: string;
  isPartCreation: boolean;
  action: Action;
  partActionType: PartActionType;
  value: PartActionCard;
  outValue?: PartActionCard; 
  inValue?: PartActionCard;
}

export interface PartActionTypes {
  code: string;
  name: string;
  type: string;
  isActive: boolean;
}

export interface ExceptionalPartData { 
  payload: any; 
  meta?: ExceptionalPartMetaData;
}

export interface ExceptionalPartMetaData{ 
  selectedPartActionData?: PartCreationOptionData; 
  partTypeValue?: PartTypeActionLiveSearchItem;
}

export interface CreateBulkPartActionsRequest {
  id: number;
  actionId?: number;
  execute: boolean;
  actionTypeCode: string;
  serviceId: number;
  installedOrMaintainedPartData: JSON;
  removedPartData: JSON;
  notes: string;
  isExceptionalCreation?: boolean;
}

export interface PendingShipmentsDataType { 
  accepted: CustomisePartActionCard[]; 
  canceled: CustomisePartActionCard[];
}

export interface PendingShipmentsDialog { 
  currentNumber: number; 
  total: number;
  onOk: () => void;
  onCancel: () => void;
}